module.exports = __webpack_public_path__ + "static/img/gaozhongzhengzhi4.d4c36e42.jpg";